import React from 'react';
import './App.css';
import Primer from './Primer';

const App: React.FC = () => {
  return (
    <div className='app'>
      <Primer />
    </div>
  );
};

export default App;
